
$(document).ready(function(e){
	if ($('.field.address-autocomplete-field').length > 0){
		$('.field.address-autocomplete-field').each(function(){
			var dom = $(this);
			var input = dom.find('input');

			var components_to_capture = {
				street_number: 'short_name',
				route: 'long_name',
				locality: 'long_name',
				administrative_area_level_1: 'short_name',
				postal_code: 'short_name'
			};

			// Init the autocomplete holder
			var autocomplete = new google.maps.places.Autocomplete(
				(input[0]),
				{
					types: [
						'geocode'
					]
				}
			);

	        // Set initial restrict to the greater list of countries.
	        autocomplete.setComponentRestrictions({'country': ['nz']});

	        // Specify only the data fields that are needed.
	        autocomplete.setFields(['address_components', 'name']);

			// When the user selects an address from the dropdown
			autocomplete.addListener('place_changed', place_changed);
			function place_changed() {
				var place = autocomplete.getPlace();
				var place_as_string = "";

				// Get each component of the address from the place details
				// and fill the corresponding field on the form.
				for (var i = 0; i < place.address_components.length; i++) {

					var address_type = place.address_components[i].types[0];

					if (components_to_capture[address_type]){
						place_as_string += place.address_components[i][components_to_capture[address_type]];

						switch (address_type){
							case 'street_number':
								place_as_string += ' ';
								break;

							case 'route':
							case 'locality':
							case 'administrative_area_level_1':
								place_as_string += ', ';
								break;
						}
					}
				}

				input.val(place_as_string);
				UpdateExecutionAddressField(input, place_as_string);
			}
		});
	}


	// If we have a delay execution address confirmation field, copy the address into it
	function UpdateExecutionAddressField(input, place_as_string) {
		if(input.attr('id') == 'Form_Form_HomeAddress') {
			if($('.field.execution-address-confirmation label span').length) {
				$('.field.execution-address-confirmation label span').html(place_as_string);
			}
		}
	}

});